import React, { useContext, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import { QMS } from "../../../_constants/actionConstants";

export default function CmtModal_Delete(props) {
  const { modalState, toggleModal } = props;

  const dispatch = useDispatch();

  const [reasonForDeletion, setReasonForDeletion] = useState("");

  const handleClick_submit = async (e) => {
    e.preventDefault();

    for (let i = 0; i < (modalState.data.issueIdsToDelete || []).length; i++) {
      console.log("removing", i);
      await dispatch(cmtIssueActions.remove(modalState.data.issueIdsToDelete[i]));
    }

    console.log("refreshing");
    dispatch(cmtIssueActions.getAll(modalState.data.divisionId));

    toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={modalState.showModal} toggle={toggleModal} fade={false} size={"md"}>
      <ModalHeader toggle={toggleModal} className="bg-danger text-white" close={closeBtn}>
        <FontAwesomeIcon icon={"exclamation-circle"} className="fa-fw mr-2" />
        Delete Issue
      </ModalHeader>
      <ModalBody>
        Are you sure you wish to delete this issue?
        {/* <div className="form-row mb-2">
          <div className="form-group col-12 mb-0 pr-1">
            <label htmlFor="reasonForDeletion" className="mb-0">
              Reason for Deletion:
            </label>
            <textarea
              name="reasonForDeletion"
              id="label"
              className="form-control"
              rows={4}
              value={reasonForDeletion}
              onChange={(e) => setReasonForDeletion(e.target.value)}
            />
          </div>
        </div> */}
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-row form-group mb-0">
          <button
            className="btn btn-secondary mr-2"
            color="secondary"
            onClick={toggleModal}
          >
            Cancel
          </button>
          <button className="btn btn-danger" name="add" onClick={handleClick_submit}>
            <b>Delete</b>
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
